import React from "react";
import s from "./index.module.scss";
import classNames from "classnames/bind";
const cx = classNames.bind(s);

const Logo = ({ text, className }) => {
	return (
		<a
			href="https://tass.ru"
			className={cx(s.logo, className)}
			rel="noopener noreferrer"
			target="_blank"
		>
			{text ? (
				<img src="images/logo_tass.svg" alt="Tass logo" />
			) : (
				<img src="images/logo_footer.svg" alt="Tass logo" />
			)}
		</a>
	);
};

export default Logo;
